import { Alert, AlertDescription, AlertTitle } from "../shadcn/alert";

export const NoxusBanner = ({
  title,
  description,
  icon,
  variant = "default",
}: {
  title?: string;
  description?: string | React.ReactNode;
  icon?: React.ReactNode;
  variant?: "default" | "destructive" | "warning";
}) => {
  return (
    <Alert variant={variant}>
      {icon}
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription>{description}</AlertDescription>
    </Alert>
  );
};
